import React from "react";
import "./programs.css";
import { Link } from "react-router-dom";

const programs = [
  {
    id: "btech-marine",
    title: "B.Tech Marine Engineering",
    duration: "Duration : 4 Years",
    description:
      "The Department of Marine Engineering aims to train the best marine engineering graduates for the industry. Along with providing a broad-based knowledge in theory....",
    image: "/assets/images/icons/marine_eng.webp",
  },
  {
    id: "bsc-nautical",
    title: "B.Sc Nautical Science",
    duration: "Duration : 3 Years",
    description:
      "The Department of Nautical Science enables the graduates to become Navigating Officers on-board merchant ships plying worldwide. The bachelor program dealing....",
    image: "/assets/images/icons/nautical_science.webp",
  },
  {
    id: "diploma-nautical",
    title: "Diploma In Nautical Science",
    duration: "Duration : 1 Years",
    description:
      "One year Diploma in Nautical Science (DNS) is a pre-sea training course approved by Directorate General of Shipping (DGS) and affiliated to MIT-ADT University...",
    image: "/assets/images/icons/diploma_nautical.webp",
  },
  {
    id: "electro-technical",
    title: "Electro Technical Officer",
    duration: "Duration : 4 Months",
    description:
      "Our Electro Technical Officer (ETO) is your pathway to a dynamic career at sea. Designed to meet the highest industry standards, this 17-week program provides....",
    image: "/assets/images/icons/ETO.webp",
  },
];

const Programs = () => {
  return (
    <div className="programs">
      <div className="programs-container">
        <h1 className="title">Programs That Shape Futures</h1>
        <h2 className="subtitle">
        Your gateway to a high-seas career starts here
        </h2>

        <div className="programs-grid">
          {programs.map((program, index) => (
            <div className="program-card" key={index}>
              <div className="program-top">
                <img src={program.image} alt="img" />
                <h3 className="pg-title">{program.title}</h3>
              </div>
              <div className="program-line"></div>

              <div className="program-info">
                <p className="program-duration">{program.duration}</p>
                <p>{program.description}</p>
              </div>
              <Link to={`/academics/${program.id}`}>
                <button id="program-btn">Explore Program</button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Programs;
